import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useOrderClose = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("useOrderCreatemethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOrderCreate-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrderCreate-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrderCreate-error-${orderId}`);

  // 发起支付
  const close = async (PayId: string) => {
    try {
      loading.value = true;
      // console.log("pay参数---------", customQuery);
      const customQuery = {
        prepay_id: PayId
      };
      const res = await context.$xbuy.api.orderClose(customQuery);
      if (res && res.code === 0) {
        result.value = res;
        error.value = null;
      } else {
        setError({ code: res.code, message: res.message });
        error.value = res.message;
        result.value = null;
      }
    } catch (err) {
      error.value = err.message;
      result.value = null;

    } finally {
      loading.value = false;
    }
  };

  return {
    closeOrder: close,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
